import { defineComponent as _defineComponent } from 'vue'
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { biBrow } from '@tencent/fit-bi-sdk';
import { elk } from '@tencent/ppd-base-libs';
import { ScanGift } from '@tencent/wphk-components-scan-gift';
import { computed, ref, toRefs, watch } from 'vue';
import { useActConfigStore } from '../../store/act-config';
import { usePromoterAct } from '../../hooks/use-promoter-act';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['showState'],
  setup(__props, { emit }) {

const { targetActConfig } = useActConfigStore();
const { spId, merchantId } = toRefs(useMerchantInfo());

const {
  disSource,
  promoterInfo,
  isInit,
} = usePromoterAct();
const scanGift = ref<InstanceType<typeof ScanGift> | null>(null);
const { getBiExt } = useGlobalBi();
/** 覆盖扫码有礼的券配置 */
const couponConfig = { couponTagText: '', themeColor: 'green' };
const couponList = ref<any[]>([]);
const customBiExt = computed(() => ({
  ...getBiExt(),
  fpromotercode: promoterInfo.value.promoterCode,
  fcanJoin: `${promoterInfo.value.isPromoterAct}`,
}));
function handleShowState(isShow: boolean) {
  emit('showState', isShow);
  elk({
    key: '24q1mainlandGiftPackBrow',
    str3: spId.value,
    str4: merchantId.value,
  });
}
watch(isInit, () => {
  if (promoterInfo.value.isPromoterAct) {
    biBrow('spring-act-module.promoter-module|推广员场景曝光', customBiExt.value);
  }
});
const handleCompReady = (isReady: boolean, { fixedCouponDetailList }) => {
  /** 组件未加载ready不处理 */
  if (!isReady) {
    return;
  }
  couponList.value = fixedCouponDetailList;
  /** 非推广员场景不处理 */
  if (!promoterInfo.value.isPromoterAct) {
    return;
  }
};

return { __sfc: true,targetActConfig, spId, merchantId, emit, disSource, promoterInfo, isInit, scanGift, getBiExt, couponConfig, couponList, customBiExt, handleShowState, handleCompReady, ScanGift }
}

})